<template>
  <div>
    <section>
        <b-card no-body class="shadow p-3 mb-5 bg-white rounded m-4">
          <div class="row">
            <div class="col-12 col-lg-2">
              <SidebarMenu
                :menus="menus"
                :selectedTab="selected"
                :expandedMenu="expandedMenu"
                :hasGenerateLink="true"
                :loadingGenerate="isGenerating"
                @select="handleMenuSelect"
                @toggle-expand="toggleExpand"
                @generate-link="generateMarketingLink"
              />
            </div>

            <div class="col-12 col-lg-10 mt-3 mt-lg-0">
              <keep-alive>
                <component :is="selected"></component>
              </keep-alive>
              <div class="text-center mt-5" v-if="selected === 'Profil'">
                <!-- <p><strong>{{ textMessage }}</strong></p> -->
                <b-button v-if="!showProductOptions && isFill" @click="showProductOptions = true" variant="primary">
                  Lihat Produk
                </b-button>

                <div v-if="showProductOptions" class="mt-3">
                  <b-button href="/list-produk-deposito" variant="success" class="mr-2">Deposito</b-button>
                  <b-button href="/list-produk-tabungan" variant="info">Tabungan</b-button>
                  <div class="mt-3">
                    <b-button variant="danger" @click="showProductOptions = false" style="background-color: transparent; border: transparent;">❌</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
    </section>
    <!-- Modal Hasil Generate Link -->
    <newCustomModal
      :visible="showLinkModal"
      @close="showLinkModal = false"
      size="medium"
      :showClose="false"
    >
      <template v-slot:default>
        <div class="text-center d-flex flex-column align-items-center">
          <img
            :src="require('@/assets/images/landing_page/logo-efunding.svg')"
            alt="logo"
            width="250"
            class="mb-3"
          />
          <h3 class="mb-2" style="font-weight: 700; color: #274C8E;">
            Link Marketing Berhasil Dibuat!
          </h3>

          <p class="text-muted mb-3">Berikut adalah link agen Anda:</p>

          <div
            class="d-flex justify-content-center align-items-center mb-3"
            style="gap: 8px; width: 100%; max-width: 500px;"
          >
            <input
              type="text"
              v-model="generatedLink"
              readonly
              class="form-control text-center"
              style="border: 1px solid #ccc; border-radius: 10px;"
            />
            <button
              class="copy-btn"
              @click="copyLink"
              :disabled="!generatedLink"
            >
              Salin
            </button>
          </div>

          <p v-if="copySuccess" style="color: #28a745; font-weight: 500;">
            ✅ Link berhasil disalin ke clipboard!
          </p>

          <div class="mt-4 d-flex justify-content-center" style="gap: 10px;">
            <button class="close-btn" @click="showLinkModal = false">
              Tutup
            </button>
          </div>
        </div>
      </template>
    </newCustomModal>

    <!-- <Footer /> -->
  </div>
</template>

<script>
import DashboardAgencyIndex from "../components/dashboard/dashboard-agency-index.vue";
import SidebarMenu from "../components/pengajuan-saya/SidebarMenu.vue";
import Profil from "../components/pengajuan-saya/profil.vue";
import PengajuanFunding from "../components/pengajuan-saya/pengajuan.vue";
import Riwayat from "../components/pengajuan-saya/riwayat.vue";
import ChangePassword from "../components/pengajuan-saya/ChangePassword.vue";
import KycSign from "../components/pengajuan-saya/KycSign.vue";
import Pengajuan from "../api/pengajuan.js";
import MonitoringAgent from "../components/dashboard/monitoring-agent.vue";
import BiayaJasaAgency from "../components/dashboard/biaya-jasa-agency.vue";
import ProfilAgency from "../components/pengajuan-saya/agency-profile.vue";
import MarketingAgency from "../api/marketingAgency.js";
import NewCustomModal from "../components/newCustomModal.vue";

export default {
  name: "Dashboard",
  components: {
    SidebarMenu,
    Profil,
    PengajuanFunding,
    Riwayat,
    ChangePassword,
    KycSign,
    MonitoringAgent,
    DashboardAgencyIndex,
    ProfilAgency,
    BiayaJasaAgency,
    NewCustomModal,
  },
  data() {
    return {
      selected: "DashboardAgencyIndex",
      isFill: false,
      textMessage: "",
      expandedMenu: "",
      showProductOptions: false,

      showLinkModal: false,
      generatedLink: "",
      isGenerating: false,
      copySuccess: false,

      menus: [
        {
          label: "Dashboard",
          component: "DashboardAgencyIndex",
        },
        {
          label: "Monitoring",
          children: [
            {
              label: "Deposito/Tabungan",
              component: "MonitoringAgent",
            },
            {
              label: "Pembiayaan",
              component: "MonitoringAgent",
              disable: true
            },
          ],
        },
        {
          label: "Ujrah",
          component: "BiayaJasaAgency",
        },
        {
          label: "Profil",
          component: "ProfilAgency",
        },
      ],
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    handleMenuSelect(menu) {
      if (menu.route) {
        this.$router.push(menu.route);
      } else if (menu.component) {
        this.selected = menu.component;
      }
    },
    toggleExpand(label) {
      this.expandedMenu = this.expandedMenu === label ? "" : label;
    },
    loadData() {
      Pengajuan.isFunderCompleteProfile().then((res) => {
        if (res.data.meta.code === 200) {
          this.isFill = true;
          this.textMessage = "Kini anda dapat melakukan pengajuan produk!";
        } else {
          this.isFill = false;
          this.textMessage = "Silahkan lengkapi profil terlebih dahulu sebelum melakukan pengajuan produk!";
        }
      });
    },
    async generateMarketingLink() {
      try {
        this.isGenerating = true;
        const res = await MarketingAgency.generateLink();
        console.log("response generate : ", res);
        if (res.data.meta.code === 200) {
          this.generatedLink = res.data.data.referral_link;
          this.showLinkModal = true;
        } else {
          this.$bvToast.toast(res.data.meta.message || "Gagal membuat link", {
            variant: "danger",
            solid: true,
          });
        }
      } catch (error) {
        console.error(error);
        this.$bvToast.toast("Terjadi kesalahan saat membuat link", {
          variant: "danger",
          solid: true,
        });
      } finally {
        this.isGenerating = false;
      }
    },
    copyLink() {
      navigator.clipboard.writeText(this.generatedLink)
        .then(() => {
          this.copySuccess = true;

          // Setelah 2 detik, hilangkan pesan sukses lagi
          setTimeout(() => {
            this.copySuccess = false;
          }, 2000);
        })
        .catch(() => {
          this.copySuccess = false;
          alert("Gagal menyalin link. Silakan coba lagi.");
        });
    }
  },
  mounted() {
    this.loadData();
  },
  created() {
    const queryTab = this.$route.query.q;
    if (queryTab === "Profil") this.selected = "Profil";
    else if (queryTab === "KycSign") this.selected = "KycSign";
  },
};
</script>
<style scoped>
.copy-btn {
  background-color: #00A1CA;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 8px 18px;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
}

.copy-btn:hover {
  background-color: #008fb3;
  transform: translateY(-1px);
}

.copy-btn:disabled {
  background-color: #a8dce9;
  cursor: not-allowed;
}

.close-btn {
  background-color: #00A1CA;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 22px 36px;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
}

.close-btn:hover {
  background-color: #008fb3;
  transform: translateY(-1px);
}
</style>


// WEBPACK FOOTER //
// src/public/agency-dashboard.vue